module.exports = __webpack_public_path__ + "home_type_ico_2.svg?809847718dc16d5adb5c57acf6654704";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_type_ico_2.svg
// module id = 22
// module chunks = 0